import i18next from '../i18n/i18n';

interface ApiError {
  status?: number;
  title?: string;
  errors?: Record<string, unknown> | unknown[] | string;
}

const hasValidationErrors = (error: ApiError): boolean => {
  if (error.errors == null) {
    return false;
  }

  if (Array.isArray(error.errors)) {
    return error.errors.length > 0;
  }

  if (typeof error.errors === 'object') {
    return Object.keys(error.errors).length > 0;
  }

  return typeof error.errors === 'string' && error.errors.trim().length > 0;
};

export const resolveErrorMessage = (error: unknown, defaultMessage: string): string => {
  if (!isApiError(error) || error.status == null) {
    return defaultMessage;
  }

  if (error.status >= 500) {
    return defaultMessage;
  }

  // For validation errors show default message
  if (hasValidationErrors(error)) {
    return defaultMessage;
  }

  // Show error from server only for 400 status
  if (error.status === 400 && error.title) {
    return error.title;
  }

  return defaultMessage;
};

const isApiError = (error: unknown): error is ApiError =>
  typeof error === 'object' && error !== null && 'status' in error;

export const getStatusError = (status: number) => {
  var errorMessage = '';
  switch (status) {
    case 400:
      errorMessage = i18next.t('errors:error400');
      break;
    /* case 401:
      errorMessage = "Neautorizuota, turite prisijungti.";
      break;  */
    case 408:
      errorMessage = i18next.t('errors:error408');
      break;
    case 500:
      errorMessage = i18next.t('errors:error500');
      break;
    default:
      errorMessage = i18next.t('errors:default');
      break;
  }

  return errorMessage;
};
